import { cn } from '@/shared/lib/utils/classnames';
import type { StatGroupBlock as StatGroupBlockType } from '@/shared/types/blocks';

type StatGroupBlockProps = Omit<StatGroupBlockType, 'type' | 'id'>;

/**
 * StatGroupBlock - 통계 그룹
 *
 * 여러 통계 항목을 그리드 형태로 표시합니다.
 */
export function StatGroupBlock({ stats, columns = 4 }: StatGroupBlockProps) {
  return (
    <div
      className={cn('grid gap-4')}
      style={{
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
      }}
    >
      {stats.map((stat) => (
        <div key={stat.id} className="flex flex-col gap-1 p-4 bg-muted rounded-lg">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            {stat.icon && <span className="text-base">{stat.icon}</span>}
            <span>{stat.label}</span>
          </div>
          <span className="text-xl font-bold text-foreground">{stat.value}</span>
        </div>
      ))}
    </div>
  );
}
